import { useContext, useEffect, useMemo, useRef } from 'react';

import isMobile from 'ismobilejs';

import { MainContext, useTranslation } from '@ezbobdev/ui-framework';

const CENTERED_ELEMENT = {
  CUSTOM_HEADER: 'CUSTOM_HEADR',
  HEADER: 'HEADER',
  CONTENT: 'CONTENT',
};

export const useScreenWrapper = (props) => {
  const { customHeader, onClickBack, title, topImage, subtitle } = props;

  const { actions } = useContext(MainContext);

  const { t, i18n } = useTranslation();

  const scrollAnchorRef = useRef(null);

  const isMobileDevice = isMobile().any;

  const { showScrollIndicatorMobile } =
    actions.settings.getUserConfigProp(`widgetsConfig.MaterialScrollIndicator`) ?? false;
  const isAppBarHidden = actions.settings.getUserConfigProp(`widgetsConfig.materialAppBar`)?.hidden;
  const customerWizardName = actions.settings.getPageRoute('customerWizard').name;
  const currentPageName = actions.userState.getCurrentPageDetails().name;
  const { stepName, progressBarStep } = actions.userState.getCurrentStepDetails();

  const isOnWizardPage = customerWizardName && customerWizardName === currentPageName;

  const hasBackButton = typeof onClickBack === 'function';
  const shouldShowScrollIndicator = showScrollIndicatorMobile && isMobileDevice;
  const shouldShowProgressBar = progressBarStep && isOnWizardPage;

  const drawerName = `${stepName}.drawer`;
  const drawerContentExists =
    isOnWizardPage && i18n.exists(`${drawerName}.content`) && t(`${drawerName}.content`) !== '';

  const wrapperTopImageSrc = topImage?.src ?? actions.settings.getUserConfigProp(`custom.${stepName}.icon.src`);
  const wrapperTopImageAlt = (topImage?.alt ?? i18n.exists(`${stepName}.icon.alt`)) ? t(`${stepName}.icon.alt`) : '';

  const centeredElement = useMemo(() => {
    if (!hasBackButton && !wrapperTopImageSrc) {
      if (customHeader) return CENTERED_ELEMENT.CUSTOM_HEADER;

      if (title || subtitle) return CENTERED_ELEMENT.HEADER;

      return CENTERED_ELEMENT.CONTENT;
    }
  }, [hasBackButton, wrapperTopImageSrc, customHeader, title, subtitle]);

  useEffect(() => {
    const focusTargetClassnames = [
      '.ScreenWrapper__progress-bar-summary',
      '.ScreenWrapper__custom-header',
      '.ScreenWrapper__header__title',
      '.ScreenWrapper__header__subtitle',
      '.ScreenWrapper__content',
    ];

    let elementToFocus = null;
    for (const target of focusTargetClassnames) {
      elementToFocus = document.querySelector(target);
      if (elementToFocus) break;
    }

    if (elementToFocus) {
      elementToFocus.tabIndex = -1;
      elementToFocus.focus();
    }
  }, []);

  return {
    centeredElement,
    drawerContentExists,
    drawerName,
    hasBackButton,
    isAppBarHidden,
    progressBarStep,
    scrollAnchorRef,
    shouldShowScrollIndicator,
    shouldShowProgressBar,
    t,
    wrapperTopImageAlt,
    wrapperTopImageSrc,
    CENTERED_ELEMENT,
  };
};
